import Cookies from 'js-cookie'
import { api } from '../config/api'
import store from '../config/store'

const axios = require('axios')

export const Methods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
}

export const makeRequest = (
  url,
  type,
  params,
  extraHeaders,
  useOldToken,
  extraOptions
) => {
  return new Promise((resolve, reject) => {
    let token = store.getState()?.auth?.token ?? null
    const userEmail = store.getState()?.auth?.impersonate_data?.email ?? null

    if (useOldToken) {
      token = store.getState()?.auth?.oldToken?.token ?? null
    }

    if (extraHeaders?.from_initial_domain) {
      url = api.initial_domain + url
      delete extraHeaders.from_initial_domain
    }

    if (!url.startsWith('http')) url = api.domain + url

    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    }

    if (extraHeaders) {
      headers = { ...headers, ...extraHeaders }
    }

    if (userEmail) {
      headers['x-switch-user'] = userEmail
    }

    let options = {
      method: type,
      headers,
    }

    // if (type !== Methods.DELETE && type !== Methods.GET) {
    options.data = params
    // }

    if (extraOptions) {
      options = { ...options, ...extraOptions }
    }

    axios
      .request(url, options)
      .then((response) => {
        if (response?.data?.jwt_mercure) {
          Cookies.set('mercureAuthorization', response?.data?.jwt_mercure, {
            expires: 86400,
          })
        }

        resolve(response.data)
      })
      .catch((error) => {
        if (error.response) {
          reject({ ...error.response.data, status: error.response.status })
          return
        }

        reject(error)
      })
  })
}
